// extracted by mini-css-extract-plugin
export var active = "index-module--active--hYkT2";
export var centered = "index-module--centered--x0TSK";
export var header = "index-module--header--+tJQO";
export var light = "index-module--light--hF34z";
export var nav = "index-module--nav--QyZqI";
export var navLink = "index-module--navLink--lo1sR";
export var noPadding = "index-module--noPadding--TKKEx";
export var reducedHeight = "index-module--reducedHeight--pEuff";
export var title = "index-module--title--qJU6W";